'use client';

import {trackSubscribeClicked} from 'iq-interview_experiences/tracking';
import {useSubscribeHref} from 'iq-upselling/hooks';

export default function SubscribePremiumBanner() {
  const subscribeHref = useSubscribeHref();

  return (
    <div className='bg-white border border-iq-grey-light rounded-xl p-4 flex flex-col gap-3'>
      <div>
        <p className='font-bold text-sm leading-snug text-iq-black'>Get unlimited access</p>
        <p className='text-iq-grey-medium text-xs mt-1'>
          Subscribe to IQ Premium for instant access to all interview guides.
        </p>
      </div>
      <a
        href={subscribeHref}
        onClick={() => void trackSubscribeClicked('banner')}
        className='bg-iq-yellow text-white text-xs font-semibold px-3 py-2 rounded-lg hover:opacity-90 transition-opacity text-center'>
        Subscribe to Premium
      </a>
    </div>
  );
}
